import { type Route } from "@angular/router";
import { LayoutComponent } from "./layout.component";

export const appRoutes: Route[] = [
  {
    path: "demo",
    loadComponent: () => import("./pages/demo.page").then((x) => x),
  },
  {
    path: "politique-de-confidentialite",
    loadComponent: () =>
      import("./pages/politique-de-confidentialite.page").then((x) => x),
  },
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "",
        loadComponent: () => import("./pages/ai-data.page").then((x) => x),
      },
      {
        path: "tendering",
        loadComponent: () => import("./pages/tendering.page").then((x) => x),
      },
      {
        path: "professionnel",
        loadComponent: () =>
          import("./pages/professionnel.page").then((x) => x),
      },
      {
        path: "gtb",
        loadComponent: () => import("./pages/gtb.page").then((x) => x),
      },
      {
        path: "cvc",
        loadComponent: () => import("./pages/cvc.page").then((x) => x),
      },
      {
        path: "isolation",
        loadComponent: () => import("./pages/isolation.page").then((x) => x),
      },
      {
        path: "audit",
        loadComponent: () => import("./pages/audit.page").then((x) => x),
      },
      {
        path: "blog",
        loadComponent: () =>
          import("./components/posts/post-list.component").then((x) => x),
      },
      {
        path: "blog/:slug",
        loadComponent: () =>
          import("./components/posts/post-detail.component").then((x) => x),
      },
      {
        path: "clients",
        loadComponent: () =>
          import("./components/use-case/use-case-list.component").then(
            (x) => x,
          ),
      },
      {
        path: "clients/:slug",
        loadComponent: () =>
          import("./components/use-case/use-case-detail.component").then(
            (x) => x,
          ),
      },
      { path: "**", redirectTo: "" },
    ],
  },
];
